import { render, staticRenderFns } from "./DeudaDetail.vue?vue&type=template&id=f8c112a6&scoped=true"
import script from "./DeudaDetail.vue?vue&type=script&lang=js"
export * from "./DeudaDetail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f8c112a6",
  null
  
)

export default component.exports